import axios from "axios";

// export const BACKEND_URL = "http://localhost:5001";
export const BACKEND_URL = "https://api.desilk.com.vn";
export const API_BASE_URL = `${BACKEND_URL}/api/v1`;

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("auth_token") ||
      sessionStorage.getItem("auth_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Add cache control headers for GET requests
    if (config.method === "get") {
      config.headers["Cache-Control"] = "no-cache, no-store, must-revalidate";
      config.headers["Pragma"] = "no-cache";
      config.headers["Expires"] = "0";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle common API errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx

      // Lấy URL của request để phân biệt lỗi 401 từ login và các request khác
      const isLoginRequest = error.config.url?.includes("/auth/login");

      switch (error.response.status) {
        case 401:
          if (!isLoginRequest) {
            // Nếu không phải là login request thì mới tự động đăng xuất và chuyển hướng
            localStorage.removeItem("auth_token");
            sessionStorage.removeItem("auth_token");
            localStorage.removeItem("user");
            window.location.href = "/login";
            return Promise.reject(
              new Error("Phiên đăng nhập hết hạn. Vui lòng đăng nhập lại.")
            );
          }
          // Nếu là login request thì chỉ chuyển tiếp lỗi để component xử lý
          return Promise.reject(error);
        case 403:
          return Promise.reject(
            new Error("Bạn không có quyền truy cập tính năng này.")
          );
        case 404:
          return Promise.reject(new Error("Không tìm thấy dữ liệu yêu cầu."));
        case 500:
          return Promise.reject(
            new Error("Lỗi hệ thống. Vui lòng thử lại sau.")
          );
        default:
          return Promise.reject(
            new Error(
              error.response.data?.message || "Đã xảy ra lỗi không xác định."
            )
          );
      }
    } else if (error.request) {
      // The request was made but no response was received
      return Promise.reject(
        new Error(
          "Không thể kết nối đến máy chủ. Vui lòng kiểm tra kết nối mạng."
        )
      );
    } else {
      // Something happened in setting up the request that triggered an Error
      return Promise.reject(new Error("Đã xảy ra lỗi khi gửi yêu cầu."));
    }
  }
);

export default api;
